const DEFAULT_MAX_SIZE_BYTES = 512_000; // 500 KB
const INITIAL_QUALITY = 0.85;
const QUALITY_STEP = 0.05;
const MIN_QUALITY = 0.3;

export async function compressToWebP(
  file: File,
  maxSizeBytes = DEFAULT_MAX_SIZE_BYTES,
): Promise<File> {
  if (!file.type.startsWith('image/')) return file;

  const bitmap = await createImageBitmap(file);
  const canvas = document.createElement('canvas');
  canvas.width = bitmap.width;
  canvas.height = bitmap.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) { bitmap.close(); return file; }
  ctx.drawImage(bitmap, 0, 0);
  bitmap.close();

  const baseName = file.name.replace(/\.[^.]+$/, '');
  const tryBlob = (q: number): Promise<Blob | null> =>
    new Promise((resolve) => canvas.toBlob(resolve, 'image/webp', q));

  let quality = INITIAL_QUALITY;
  while (quality >= MIN_QUALITY) {
    const blob = await tryBlob(quality);
    if (!blob) break;
    if (blob.size <= maxSizeBytes || quality === MIN_QUALITY) {
      return new File([blob], `${baseName}.webp`, { type: 'image/webp', lastModified: Date.now() });
    }
    quality = Math.round((quality - QUALITY_STEP) * 100) / 100;
  }
  const fallback = await tryBlob(MIN_QUALITY);
  return fallback
    ? new File([fallback], `${baseName}.webp`, { type: 'image/webp', lastModified: Date.now() })
    : file;
}

export async function compressFilesToWebP(
  files: File[],
  maxSizeBytes = DEFAULT_MAX_SIZE_BYTES,
): Promise<File[]> {
  return Promise.all(files.map((f) => compressToWebP(f, maxSizeBytes)));
}
